import * as dateFns from 'date-fns'

export function getMonthlyTicks(startingTimestamp: number, endingTimestamp: number, dayOfMonth = 1) {
  const ticks: number[] = []
  const endingDate = new Date(endingTimestamp)
  const initTimestamp = new Date(startingTimestamp)
  const startDate = dateFns.setDate(initTimestamp, dayOfMonth)
  let date = dateFns.isBefore(startDate, initTimestamp) ? dateFns.addMonths(startDate, 1) : startDate

  while (date <= endingDate) {
    ticks.push(date.getTime())
    date = new Date(date.getFullYear(), date.getMonth() + 1, dayOfMonth)
  }

  return ticks
}
